export default __webpack_public_path__ + "static/media/spark_57.8e11279a.png";